<template>
  <div class="l-row--t64 module tri-pic">
    <div class="g-row">
      <div class=" g-col--6 g-col--2s tri-pic__col hoverImg" @mouseenter="methods.onHover">
        <div class="c-pic i--item-3">
          <Picture :src="data.target.items[2].src" :coverSrc="data.target.items[2].coverSrc" :parallax="data.target.items[2].parallax == 0 ? false : true" :embedType="data.target.items[2].embedType" :ratio="data.target.items[2].ratio"/>
          <div class="c-pic__desc">
            <div class="t-b--13">
              <span class="t--fak c-pic__desc--info"><span class="t--ft">(</span>003<span class="t--ft">)</span></span>
            </div>
          </div>
        </div>
      </div>
      <div class="g-col--9 g-col--3s tri-pic__col g-nml--4 g-nmr--1 g-nml--1s g-nmr--1s hoverImg" @mouseenter="methods.onHover">
        <div class="c-pic i--item-2">
          <Picture :src="data.target.items[1].src" :coverSrc="data.target.items[1].coverSrc" :parallax="data.target.items[1].parallax == 0 ? false : true" :embedType="data.target.items[1].embedType" :ratio="data.target.items[1].ratio"/>
          <div class="c-pic__desc">
            <div class="t-b--13">
              <span class="t--fak c-pic__desc--info"><span class="t--ft">(</span>002<span class="t--ft">)</span></span>
            </div>
          </div>
        </div>
      </div>
      <div class="g-col--3 g-col--2s tri-pic__col hoverImg" @mouseenter="methods.onHover">
        <div class="c-pic i--item-1">
          <Picture :src="data.target.items[0].src" :coverSrc="data.target.items[0].coverSrc" :parallax="data.target.items[0].parallax == 0 ? false : true" :embedType="data.target.items[0].embedType" :ratio="data.target.items[0].ratio"/>
          <div class="c-pic__desc">
            <div class="t-b--13">
              <span class="t--fak c-pic__desc--info"><span class="t--ft">(</span>001<span class="t--ft">)</span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
		<div class="l-mdl--16 l-mdl--32s l-mdl--32l g-row s--h-end">
			<div class="g-col--5 g-col--4l g-col--3s g-mr--1 g-mr--2l mood-board-desc">
        <div class="t-b--13 i--body-en" v-html="data.target.body">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { computed, onMounted, ref, reactive, watch, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";

export default {
  props: ["idx", "bindRoot"],
  components: {
    Picture
  },
  setup(props) {
    const { state, get, commit } = useStore();
    const self = ref();
    const data = reactive({
      target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
    })
  
    const methods = {
      onHover: (e) => {
        // const currentImg = e.target;
        // const imgs = $.qsa(".hoverImg");
        // const zIndexImgs =  _.go(
        //  imgs,
        //  _.map(i => i.style.zIndex),
        // );
        // const zIndex = Math.max(...zIndexImgs);
        // $.setCss({
        //  "z-index": zIndex + 10
        // }, currentImg);
        const imgs = $.qsa(".hoverImg");
        const zIndex = parseInt(e.target.style.zIndex); 

        if (zIndex !== 30) {
          $.setCss({
            "z-index": 30
          }, e.target);

          _.go(
            imgs,
            _.filter(i => i !== e.target),
            _.forEach(img => {
              const zIndex = parseInt(img.style.zIndex);
              $.setCss({
                "z-index": Math.max(zIndex - 10, 10)
              }, img);
            })
          )
        }
      }
    }

    onMounted(()=> {
      // const imgs = $.qsa(".hoverImg");
      //  imgs.forEach((img, index) => {
      //      $.setCss({
      //        "z-index": 30 - (10 * index)
      //      }, img);
      //      console.log({action: "onMounted", img, index})
      //  })
    })

    return {
      self,
      data,
      methods
    };
  },
};
</script>

<style scoped lang="scss">
.tri-pic {
  &__col {
    &:nth-child(1) {
      align-self: flex-end;
      z-index: 20;
    }
    &:nth-child(2) {
      margin-bottom: 112em;
      z-index: 10;
      .__w600 & {
        margin-top: 64em;
        margin-bottom: 64em;
      }
    }
    &:nth-child(3) {
      margin-top: 128em;
      align-self: flex-start;
      z-index: 0;
      .__w600 & {
        margin-top: 0;
      }
    }
  }
}
.mood-board-desc {
	.__w600 & {
		margin-right: calc(var(--gutter)/2);
	}
}
.i--body-en {
	text-transform: uppercase;
}
</style>